import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  basket: [],
  delivery: [],
};

const basketSlice = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    setBasket(state, { payload }) {
      state.basket = payload;
    },
    addBasketItem(state, { payload }) {
      const mass = state.basket.filter(item => item.id !== payload.id);
      const basket = [...mass, payload];
      state.basket = basket;
      localStorage.setItem('basket', JSON.stringify(basket));
    },
    deleteBasketItem(state, { payload }) {
      const basket = state.basket.filter(item => item.id !== payload.id);
      state.basket = basket;
      localStorage.setItem('basket', JSON.stringify(basket));
    },
    clearBasket(state) {
      state.basket = [];
      localStorage.setItem('basket', '[]');
    },
    setDelivery(state, { payload }) {
      state.delivery = payload;
    },
  },
});

export const { setBasket, addBasketItem, deleteBasketItem, clearBasket, setDelivery } = basketSlice.actions;
export default basketSlice.reducer;
